module.exports = __webpack_public_path__ + "img/horizontal_6_7_7016.a6930018.png";